import React from "react";
import styled from "styled-components";
import pricingData from "../../data/menu2/naturePoolPricingData.json";
import {device} from "../../assets/styles/media.js";
import {useMediaQuery} from "react-responsive";

const TableSection = styled.section`
    ${device.mobile} {
        position: relative;
    }
`;


const SubTitle = styled.h4`
    min-width: ${({width}) => width || '100%'};
    height: 50px;
    line-height: 50px;
    background-color: #5233d0;
    font-weight: bold;
    color: #fff;
    font-size: 18px;
    border-radius: 10px 10px 0 0;

    span {
        font-weight: 400;
        margin-left: 3px;
    }

    ${device.pc} {
        min-width: 220px

    }

    ${device.tablet} {
        min-width: 200%;
    }

    ${device.mobile} {
        width: 200%;
        font-size: 14px;
        height: 26px;
        line-height: 26px;

        span {
            font-size: 12px
        }
    }
`;

const TableWrap = styled.div`
    overflow-x: auto;
    margin-bottom: 50px;

    ${device.tablet} {
        margin-bottom: 20px;
    }

    ${device.mobile} {
        margin-bottom: 20px;
    }
`;
const TableWrap2 = styled.div`
    display: flex;
    position: relative;

    ${device.mobile} {
        flex-direction: column;
    }
`;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    font-size: 14px;

    th, td {
        border: 1px solid #dddddd;
        padding: 15px;
    }

    th {
        font-weight: bold;
        font-size: 18px;
    }

    td {
        font-size: 16px;
    }

    ${device.tablet} {
        th, td {
            padding: 12px;
            font-size: 15px;
        }
    }

    ${device.mobile} {
        margin-top: 10px;

        th, td {
            padding: 5px;
            font-size: 12px;
        }
    }
`;
const TimeBox = styled.div`
    display: flex;
    text-align: center;
    justify-content: space-between;

    ${device.mobile} {
        width: 200%;
    }
`;

const LastTime = styled.p`
    width: 100%;
    padding: 10px 0;
    font-size: 15px;
    opacity: 0.8;
    text-align: center;

    ${device.mobile} {
        width: 100%;
        font-size: 12px;
        font-weight: 600;
    }
`;

const PricingTable = () => {
    const {midSeason, highSeason} = pricingData;
    const isMobile = useMediaQuery({maxWidth: 600});

    return (
        <TableSection>
            <TableWrap>
                <StyledTable>
                    <SubTitle>
                        {midSeason.subTitle}
                        <span> {midSeason.time}</span>
                    </SubTitle>
                    <colgroup>
                        <col style={{width: isMobile ? "50%" : "30%"}}/>
                        <col style={{width: isMobile ? "50%" : "70%"}}/>
                    </colgroup>
                    <tbody>
                    {midSeason.items.map((item, idx) => (
                        <tr key={idx}>
                            <th scope="row">{item.label}</th>
                            <td>{item.price}</td>
                        </tr>
                    ))}
                    </tbody>
                </StyledTable>
                <LastTime>{midSeason.lastTime}</LastTime>
            </TableWrap>
            <TableWrap2>
                {highSeason.tickets.map((ticket, i) => (
                    <StyledTable key={i}>
                        <SubTitle>
                            {ticket.subTitle}
                            <span> {ticket.time}</span>
                        </SubTitle>
                        <colgroup>
                            <col style={{width: "50%"}}/>
                            <col style={{width: "50%"}}/>
                        </colgroup>
                        <tbody>
                        {ticket.items.map((item, idx) => (
                            <tr key={idx}>
                                <th scope="row">{item.label}</th>
                                <td>{item.price}</td>
                            </tr>
                        ))}
                        </tbody>
                        {isMobile ? <TimeBox>
                            <LastTime> {ticket.lastTime}</LastTime>
                        </TimeBox> : ""}
                    </StyledTable>
                ))}
            </TableWrap2>
            {!isMobile ? <TimeBox>
                {highSeason.tickets.map((tickets, i) => (
                    <LastTime key={i}>{tickets.lastTime}</LastTime>
                ))}
            </TimeBox> : ""}
        </TableSection>
    );
};

export default PricingTable;
